module.exports = __webpack_public_path__ + "img/antes_despues_73.70143fb0.png";